<p-button label="Nav" icon="pi pi-compass" iconPos="left" styleClass="p-button-text flex button-secondary border-round-lg h-full"
  (onClick)="open()">
</p-button>

<p-dialog [(visible)]="visible" [modal]="true" [draggable]="false" [resizable]="false"
  appendTo="body" [blockScroll]="true" [dismissableMask]="true"
  [breakpoints]="{ '5550px': '40vw', '1024px': '60vw', '575px': '90vw' }"
  [contentStyle]="{ padding: '1rem' }"
  styleClass="w-full md:w-6 lg:w-4 border-round-2xl border-1 border-primary surface-0 shadow-4 overflow-hidden">

  <ng-template pTemplate="header">
    <div class="flex flex-1 flex-column align-items-center gap-2">
      <span class="text-xl font-bold text-900">Product Navigation</span>
      <span class="text-sm text-600">Click to view available products</span>
    </div>
  </ng-template>

  @if (visible) {
    <div class="flex flex-column gap-3">

      <div class="flex flex-wrap justify-content-center gap-3">
        @for (product of products(); track product.type) {
          <div class="relative flex-shrink-0">
            <div class="inline-flex align-items-center justify-content-center gap-2 px-4 border-1 border-round-3xl cursor-pointer text-sm font-medium white-space-nowrap surface-0"
              style="height: 44px;"
              [ngClass]="product.type === selectedProduct() ? 'border-primary text-primary bg-blue-50' : 'border-600 text-600'"
              [attr.aria-pressed]="product.type === selectedProduct()"
              [pTooltip]="product.tooltip"
              tooltipPosition="top"
              (click)="selectProduct(product.type)">
              <i [class]="product.icon" class="text-lg"></i>
              <span>{{ product.label }}</span>
            </div>
            <i [class]="product.statusIcon" class="absolute top-0 right-0" style="width: 16px;"></i>
          </div>
        }
      </div>

      @if (selectedProduct()) {
        <div class="border-1 border-primary border-round-2xl bg-offer-blue p-3 flex flex-column gap-3">
          @switch (selectedProduct()) {
            @case (productTypes.INTERNET) {
              <ng-container [ngTemplateOutlet]="internetPackagesTemplate"></ng-container>
            }
            @case (productTypes.WIRELESS) {
              <ng-container [ngTemplateOutlet]="wirelessPackagesTemplate"></ng-container>
            }
            @case (productTypes.VIDEO) {
              <ng-container [ngTemplateOutlet]="videoPackagesTemplate"></ng-container>
            }
            @case (productTypes.VOICE) {
              <ng-container [ngTemplateOutlet]="voicePackagesTemplate"></ng-container>
            }
            @case (productTypes.PROTECTION) {
              <ng-container [ngTemplateOutlet]="protectionPackagesTemplate"></ng-container>
            }
          }

          <div class="flex justify-content-center">
            <p-button [label]="'GO TO ' + selectedProductLabel().toUpperCase() + ' PACKAGES'"
              styleClass="p-button-outlined border-round-lg font-semibold text-sm bg-white" (onClick)="goToPackages()">
            </p-button>
          </div>
        </div>
      }

      <div class="flex flex-column align-items-center gap-3">
        @if (inProgressProduct(); as inProgress) {
          <span class="text-sm text-600">
            You have an <span class="font-bold text-900">{{ inProgress.label }} order</span> in progress.
          </span>
        }

        @if (canShowOrderOptions()) {
          @if (!removeConfirmationVisible) {
            <button pButton type="button"
              class="p-button-outlined border-round-lg font-semibold text-sm inline-flex align-items-center gap-2"
              (click)="orderOptionsMenu.toggle($event)">
              <i class="pi pi-sliders-h"></i>
              <span>ORDER OPTIONS</span>
              <i class="pi" [ngClass]="orderOptionsOpen ? 'pi-angle-up' : 'pi-angle-down'"></i>
            </button>

            <p-menu #orderOptionsMenu [model]="orderOptionItems" [popup]="true" appendTo="body"
              styleClass="border-1 border-round-lg shadow-4" (onShow)="orderOptionsOpen = true"
              (onHide)="orderOptionsOpen = false">
              <ng-template pTemplate="item" let-item>
                <a class="p-menuitem-link flex align-items-center gap-2 text-red-600 font-semibold white-space-nowrap py-3 px-4">
                  <i [class]="item.icon"></i>
                  <span>{{ item.label }}</span>
                </a>
              </ng-template>
            </p-menu>
          }

          @if (removeConfirmationVisible) {
            <div class="border-1 border-red-500 border-round-lg bg-red-50 p-4 flex flex-column gap-3 w-full md:w-10">
              <div class="flex align-items-start gap-3">
                <i class="pi pi-exclamation-triangle text-red-600 text-xl mt-1"></i>
                <div class="flex flex-column gap-2">
                  <span class="font-semibold text-lg text-900">Remove {{ selectedProductLabel() }} from order?</span>
                  <span class="text-sm text-700">All current progress will be lost. Please confirm before proceeding.</span>
                </div>
              </div>
              <div class="flex justify-content-end gap-3">
                <p-button label="KEEP PRODUCT" styleClass="p-button-outlined border-round-lg font-semibold"
                  (onClick)="keepProduct()">
                </p-button>
                <p-button label="REMOVE PRODUCT" severity="danger" styleClass="border-round-lg font-semibold"
                  (onClick)="confirmRemoveProduct()">
                </p-button>
              </div>
            </div>
          }
        }

        <p-button label="CONTINUE ORDER" styleClass="p-button-raised border-round-lg font-semibold w-16rem"
          (onClick)="continueOrder()">
        </p-button>
      </div>

    </div>
  }
</p-dialog>

<ng-template #internetPackagesTemplate>
  @for (group of packageGroups(); track group.provider) {
    <div class="flex flex-column gap-2">
      <ng-container [ngTemplateOutlet]="providerHeaderTemplate" [ngTemplateOutletContext]="{ group: group }"></ng-container>

      <div class="grid">
        @for (item of group.packages; track item.Code) {
          <div class="col-12 md:col-6">
            <div class="surface-0 border-1 surface-border border-round-lg p-2 h-full flex flex-column gap-1">
              <span class="font-semibold text-sm text-900">{{ item.FullName }}</span>
              @if (item.DownloadSpeed) {
                <span class="text-xs text-600">
                  Up/down speed: {{ item.DownloadSpeed }} {{ item.DownloadUnit }}
                </span>
              }
              <span class="font-bold text-sm text-900">{{ item.StandardFees?.Fee | currency }}/mo*</span>
            </div>
          </div>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #wirelessPackagesTemplate>
  @for (group of packageGroups(); track group.provider) {
    <div class="flex flex-column gap-2">
      <ng-container [ngTemplateOutlet]="providerHeaderTemplate" [ngTemplateOutletContext]="{ group: group }"></ng-container>

      <div class="grid">
        @for (item of group.packages; track item.Code) {
          <div class="col-12 md:col-6">
            <div class="surface-0 border-1 surface-border border-round-lg p-2 h-full flex flex-column gap-1 align-items-center">
              <span class="font-semibold text-sm text-900">{{ item.FullName || item.Name }}</span>
              <!-- <span class="text-xs text-600" *ngIf="item.ProductName">{{ item.ProductName }}</span> -->
            </div>
          </div>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #videoPackagesTemplate>
  @for (group of packageGroups(); track group.provider) {
    <div class="flex flex-column gap-2">
      <ng-container [ngTemplateOutlet]="providerHeaderTemplate" [ngTemplateOutletContext]="{ group: group }"></ng-container>

      <div class="grid">
        @for (item of group.packages; track item.Code) {
          <div class="col-12 md:col-6">
            <div class="surface-0 border-1 surface-border border-round-lg p-2 h-full flex flex-column gap-1">
              <span class="font-semibold text-sm text-900">{{ item.FullName || item.Name }}</span>
              @if (item.NumberChannels) {
                <span class="text-xs text-600">{{ item.NumberChannels }} channels</span>
              }
              @if (item.Language) {
                <span class="text-xs text-600">{{ item.Language }}</span>
              }
              <span class="font-bold text-sm text-900">{{ item.StandardFees?.Fee | currency }}/mo*</span>
            </div>
          </div>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #voicePackagesTemplate>
  @for (group of packageGroups(); track group.provider) {
    <div class="flex flex-column gap-2">
      <ng-container [ngTemplateOutlet]="providerHeaderTemplate" [ngTemplateOutletContext]="{ group: group }"></ng-container>

      <div class="grid">
        @for (item of group.packages; track item.Code) {
          <div class="col-12 md:col-6">
            <div class="surface-0 border-1 surface-border border-round-lg p-2 h-full flex flex-column gap-1">
              <span class="font-semibold text-sm text-900">{{ item.FullName || item.Name }}</span>
              @if (item.ShortDescription) {
                <span class="text-xs text-600">{{ item.ShortDescription }}</span>
              }
              <span class="font-bold text-sm text-900">{{ item.StandardFees?.Fee | currency }}/mo*</span>
            </div>
          </div>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #protectionPackagesTemplate>
  @for (group of packageGroups(); track group.provider) {
    <div class="flex flex-column gap-2">
      <ng-container [ngTemplateOutlet]="providerHeaderTemplate" [ngTemplateOutletContext]="{ group: group }"></ng-container>

      <div class="grid">
        @for (item of group.packages; track item.Code) {
          <div class="col-12 md:col-6">
            <div class="surface-0 border-1 surface-border border-round-lg p-2 h-full flex flex-column gap-1">
              <span class="font-semibold text-sm text-900">{{ item.FullName || item.Name }}</span>
              @if (item.ShortDescription) {
                <span class="text-xs text-600">{{ item.ShortDescription }}</span>
              }
              <span class="font-bold text-sm text-900">{{ item.StandardFees?.Fee | currency }}/mo*</span>
            </div>
          </div>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #providerHeaderTemplate let-group="group">
  <div class="flex align-items-center justify-content-between">
    <span class="font-semibold text-900">{{ group.provider }}</span>
    <span class="text-xs font-semibold color-sara-blue surface-0 border-round-3xl px-2 py-1">
      {{ group.packages.length }} packages
    </span>
  </div>
</ng-template>